import * as React from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';
import cx from 'classnames';
import { getCobrandedStore } from 'utils/miscUtils';
import { MarketplaceId } from '@rome/request/marketplace/MarketplaceId';
import { WidgetTypeV4 } from '@rome/response/page/v4/WidgetTypeV4';
import { withRouter } from 'react-router';
import offersStoreStyles from './CoBrandStoreStyles/offersStore.header.css';
import itzcashStoreStyles from './CoBrandStoreStyles/itzcashStore.header.css';
import yahooStoreStyles from './CoBrandStoreStyles/yahooStore.header.css';
import indusindStoreStyles from './CoBrandStoreStyles/indusindStore.header.css';
import axisStoreStyles from './CoBrandStoreStyles/axisStore.header.css';
import sbiyonoStoreStyles from './CoBrandStoreStyles/sbiyonoStore.header.css';
import groceryStyles from './CoBrandStoreStyles/grocery.css';
import headerstyle from './header.css';
import Logo from './HeaderComponents/Logo/Logo';
import AccountMenu from './HeaderComponents/MenuComponents/AccountDropDown';
import HelpMenu from './HeaderComponents/MenuComponents/HelpMenuDropDown';
import CartIcon from './HeaderComponents/CartIcon/CartIcon';
import SignupLoginMenu from './HeaderComponents/MenuComponents/SignupLoginMenu';
import Search from 'components/Header/Search/Search';
import HelpCentrePlaceholder from 'pages/HelpCentrePage/HelpCentrePlaceholder';
import GoToFlipkartLogo from './HeaderComponents/Logo/GoToFlipkartLogo';
import { isInit, isError, isSuccess } from 'utils/asyncStatusHelper';
import { getObject, setObject } from 'utils/localStorage';
import { HP_LOGIN_WINDOW_SHOW_SESSIONS_LIMIT, HP_LOGIN_WINDOW_SHOW_PER_SESSION_LIMIT } from 'constants/LoginConstants';
import LoginSignupModal from 'components/LoginSignupWidget/LoginSignupModal';
import { fetchUserStateAction } from 'actions/userStateActions';
import { getMarketplaceServiceability } from 'actions/marketplaceServiceabilityActions';
import { NavMenuContainer } from './NavMenuContainer';
import * as HeaderUtils from './HeaderWidgetUtil';
import MSPincodeWidget from './HeaderComponents/MSPincodeWidget/MSPincodeWidget';
import { Chevron } from 'components/Icons/Icons';
const HeaderWidgetType = HeaderUtils.HeaderWidgetType;
export class Header extends React.Component {
    constructor(props) {
        super(props);
        this.cobrandedStore = '';
        this.coBrandedStyle = {};
        this.getCoBrandStyle = (cobrandedStore) => {
            switch (cobrandedStore) {
                case 'offers':
                    return offersStoreStyles;
                case 'itzcash':
                    return itzcashStoreStyles;
                case 'indusind':
                    return indusindStoreStyles;
                case 'yahoo':
                    return yahooStoreStyles;
                case 'axis':
                    return axisStoreStyles;
                case 'grocery':
                    return groceryStyles;
                case 'yono':
                    return sbiyonoStoreStyles;
                default:
                    return null;
            }
        };
        this.renderLogo = (styles) => {
            const coBrandStyle = this.getCoBrandStyle(this.cobrandedStore);
            const logoKey = this.props.isGrocery ? 'supermart-logo' : 'flipkart-logo';
            return (<div className={styles['logo-container']} key={logoKey}>
				<Logo {...this.props} cobrandedStore={this.cobrandedStore} coBrandStyles={coBrandStyle}/>
			</div>);
        };
        this.renderGotoFlipkart = () => {
            return this.props.isGrocery && <GoToFlipkartLogo {...this.props} key="gotofk"/>;
        };
        this.renderSearch = (styles) => {
            const { isGrocery, isHelpCentre } = this.props;
            return (<div className={styles['search-bar']} key="search">
				{isHelpCentre ? <HelpCentrePlaceholder /> : <Search isGrocery={isGrocery}/>}
			</div>);
        };
        this.renderTitle = (item, styles) => {
            const title = get(item, 'extraProps.Title') || '';
            return (title && (<div className={styles['title-bar']} key="title">
					<Chevron className={styles['chevron-icon-rotate']} pathClassName={styles['chevron-icon']} width={6} height={13}/>
					{title}
				</div>));
        };
        this.renderCartIcon = (styles) => {
            return (!this.props.minimal && (<div className={styles['action-item']} key="carticon">
					<CartIcon {...this.props} coBrandStyles={this.coBrandedStyle}/>
				</div>));
        };
        this.renderAccount = (styles) => {
            const { userState } = this.props;
            const isLoggedIn = userState && isSuccess(userState) && userState.isLoggedIn;
            return (<div className={cx(styles['action-item'], { [styles['login-widget']]: !isLoggedIn })} key="account">
				{isLoggedIn ? (<AccountMenu {...this.props} coBrandStyles={this.coBrandedStyle}/>) : (<SignupLoginMenu {...this.props} coBrandStyles={this.coBrandedStyle}/>)}
			</div>);
        };
        this.renderPincodeWidget = (styles) => {
            const { userState } = this.props;
            return (<div className={cx(styles['action-item'], styles['pincode-widget'])} key="pincode">
				<MSPincodeWidget {...this.props} userState={userState}/>
			</div>);
        };
        this.renderHelpMenu = (styles) => {
            const { cobrandedConfig } = this.props;
            let store = {};
            if (this.cobrandedStore && get(cobrandedConfig, [this.cobrandedStore, 'store-link'])) {
                store = cobrandedConfig[this.cobrandedStore];
            }
            return (<div className={styles['action-item']} key="help">
				<HelpMenu {...this.props} store={store} coBrandStyles={this.coBrandedStyle}/>
			</div>);
        };
        this.autoLoginWindowCloseInHPHandler = () => {
            const { isHomePage } = this.props;
            if (isHomePage) {
                let HPLWShownSessionsCount = getObject('HPLWShownSessionsCount', 'localStorage');
                HPLWShownSessionsCount = HPLWShownSessionsCount === null ? 0 : parseInt(HPLWShownSessionsCount, 10);
                if (HPLWShownSessionsCount < HP_LOGIN_WINDOW_SHOW_SESSIONS_LIMIT) {
                    let HPLWClosedPerSessionCount = getObject('HPLWClosedPerSessionCount', 'sessionStorage');
                    HPLWClosedPerSessionCount = HPLWClosedPerSessionCount === null ? 0 : parseInt(HPLWClosedPerSessionCount, 10);
                    if (HPLWClosedPerSessionCount < HP_LOGIN_WINDOW_SHOW_PER_SESSION_LIMIT) {
                        HPLWClosedPerSessionCount++;
                        setObject('HPLWClosedPerSessionCount', HPLWClosedPerSessionCount, 'sessionStorage');
                        if (HPLWClosedPerSessionCount === HP_LOGIN_WINDOW_SHOW_PER_SESSION_LIMIT) {
                            HPLWShownSessionsCount++;
                            setObject('HPLWShownSessionsCount', HPLWShownSessionsCount, 'localStorage');
                        }
                    }
                }
            }
        };
        this.renderWidgets = (item, styles, index) => {
            const { widgetList, type } = item;
            const innerItems = (widgetList &&
                widgetList.map((innerItem, key) => {
                    return this.renderWidgets(innerItem, styles, key);
                })) ||
                [];
            switch (type) {
                case HeaderWidgetType.SIDE_CONTAINER:
                    return (<div className={styles['header-side']} key={`side-${index}`}>
						{innerItems}
					</div>);
                case HeaderWidgetType.CENTER_CONTAINER:
                    return (<div className={styles['header-center']} key={`center-${index}`}>
						{innerItems}
					</div>);
                case HeaderWidgetType.FK_GO_TO_HOME:
                    return this.renderGotoFlipkart();
                case HeaderWidgetType.LOGO:
                    return this.renderLogo(styles);
                case HeaderWidgetType.SEARCH_BAR:
                    return this.renderSearch(styles);
                case HeaderWidgetType.ACC_MENU:
                    return this.renderAccount(styles);
                case HeaderWidgetType.PINCODE_DROPDOWN:
                    return this.renderPincodeWidget(styles);
                case HeaderWidgetType.HELP_MENU:
                    return this.renderHelpMenu(styles);
                case HeaderWidgetType.CART_ICON:
                    return this.renderCartIcon(styles);
                case HeaderWidgetType.TITLE:
                    return this.renderTitle(item, styles);
                default:
                    break;
            }
        };
        const { hostname, cobrandedConfig } = props;
        this.cobrandedStore = getCobrandedStore(hostname, cobrandedConfig);
        this.coBrandedStyle = this.getCoBrandStyle(this.cobrandedStore);
    }
    componenWillReceiveProps(nextProps) {
        const { hostname, cobrandedConfig } = nextProps;
        this.cobrandedStore = getCobrandedStore(hostname, cobrandedConfig);
        /* Grocery serviceability is checked every time pincode changes. And if serviceability status changes nav menu data is re-fetched. Grocery serviceability is determined by two factors, flag sent by mapi and whether pin code is set or not. */
        if (nextProps.userState.pincode !== this.props.userState.pincode) {
            this.props.getMarketplaceServiceability();
        }
    }
    componentDidMount() {
        const { userState } = this.props;
        if (isInit(userState) || (isError(userState) && get(userState.error, 'ERROR_CODE') === 408)) {
            this.props.fetchUserState();
        }
        const pixelTrackingUrl = get(this.props.cobrandedConfig, [this.cobrandedStore, 'pixel-tracking-url']);
        const searchPixelTrackingUrl = get(this.props.cobrandedConfig, [this.cobrandedStore, 'search-pixel-url']);
        if (pixelTrackingUrl) {
            if (this.cobrandedStore === 'yahoo') {
                if (this.props.enableYahooPixel)
                    new Image().src = pixelTrackingUrl;
            }
            else {
                new Image().src = pixelTrackingUrl;
            }
        }
        if (searchPixelTrackingUrl) {
            new Image().src = searchPixelTrackingUrl;
        }
    }
    render() {
        const { minimal, userState, omniturePageType, isGrocery, abExperiments, pageType, hostname, cobrandedConfig, isPincodeWidgetPresent, disableNavMenu, isHomePage } = this.props;
        this.cobrandedStore = getCobrandedStore(hostname, cobrandedConfig);
        this.coBrandedStyle = isGrocery ? this.getCoBrandStyle('grocery') : this.getCoBrandStyle(this.cobrandedStore);
        const styles = Object.assign({}, headerstyle, this.coBrandedStyle);
        const widgetList = HeaderUtils.getWidgetList({
            minimal,
            abExperiments,
            isGrocery,
            pageType,
            isPincodeWidgetPresent
        });
        const isMinimal = minimal === 'CART' || minimal === 'CHECKOUT';
        return (<React.Fragment>
				<div className={cx(styles['header-container'], { [styles['non-sticky']]: isMinimal })}>
					<div className={styles['main']}>
						{widgetList.map((item, i) => {
            return this.renderWidgets(item, styles, i);
        })}
					</div>
					{isSuccess(userState) && !userState.isLoggedIn ? (<LoginSignupModal pageType={omniturePageType} loginSource="Launch" loginModalCloseHandler={this.autoLoginWindowCloseInHPHandler}/>) : null}
					{minimal !== 'CHECKOUT' && minimal !== 'TRAVEL' && minimal !== 'TRAVEL_CHECKOUT' && (<div className={cx(styles['box-shadow'], { [styles['grocery']]: isGrocery })}/>)}
				</div>
				{minimal ? null : (<NavMenuContainer showRichNav={isHomePage} isGrocery={isGrocery} pageType={pageType} disableNavMenu={disableNavMenu}/>)}
			</React.Fragment>);
    }
}
const mapStateToProps = (state, ownProps) => {
    const marketplace = (get(ownProps.router, 'location.query.marketplace') || '').toUpperCase() ||
        get(state.productPage, 'productDetails.pageContext.marketplace') ||
        get(state.pageDataV4, 'page.pageData.pageContext.marketplace');
    const groceryPincodeWidget = state.grocery.marketPlacePincodeReducer;
    const pincodeWidgetType = get(groceryPincodeWidget, ['type']);
    const isPincodeWidgetPresent = pincodeWidgetType === WidgetTypeV4.PINCODE_SERVICEABILITY || pincodeWidgetType === WidgetTypeV4.MNS_PINCODE_POPUP;
    return {
        abExperiments: state.abExperiments,
        isGrocery: marketplace === MarketplaceId.GROCERY,
        isPincodeWidgetPresent,
        userState: state.userState,
        cobrandedConfig: get(state, ['config', 'data', 'cobrandedExperience']),
        enableYahooPixel: get(state, ['config', 'data', 'globalConfig', 'enableYahooPixel']),
        disableNavMenu: get(state, ['config', 'data', 'globalConfig', 'disableNavMenu']),
        hostname: state.misc.hostname
    };
};
const mapDispatchToProps = {
    getMarketplaceServiceability,
    fetchUserState: fetchUserStateAction
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Header));
